"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireWildcard(require("../../../utils/system"));

var _FormControlGroupContext = require("../FormControlGroupContext/FormControlGroupContext");

var _jsxRuntime = require("react/jsx-runtime");

var _variants;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var propTypes = {
  plain: _propTypes.bool,
  isValid: _propTypes.bool,
  size: (0, _propTypes.oneOf)(Object.values(sizes)),
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  })
};
var defaultProps = {
  plain: false,
  isValid: true,
  size: sizes.md,
  classes: {
    root: null
  }
};
var FormControl = (0, _system["default"])('input')({
  label: 'FormControl'
}, function (_ref) {
  var plain = _ref.plain,
      isValid = _ref.isValid;
  return (0, _css["default"])({
    '&::placeholder': {
      fontStyle: 'italic',
      color: 'text',
      opacity: 0.6
    },
    background: 'white',
    border: '1px',
    borderColor: function borderColor() {
      if (!isValid) return 'danger';
      return plain ? 'transparent' : 'gray.400';
    },
    borderRadius: 'md',
    boxSizing: 'border-box',
    color: 'text',
    display: 'inline-block',
    fontFamily: 'body',
    fontWeight: 'normal',
    lineHeight: 'base',
    m: 0,
    p: 0,
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    width: '100%'
  });
}, (0, _styledSystem.variant)({
  prop: 'cSize',
  scale: 'formControl',
  variants: (_variants = {}, _defineProperty(_variants, sizes.sm, {
    fontSize: 'sm',
    height: 8,
    px: 3
  }), _defineProperty(_variants, sizes.md, {
    fontSize: 'md',
    height: 10,
    px: 4
  }), _defineProperty(_variants, sizes.lg, {
    fontSize: 'md',
    height: 12,
    px: 4
  }), _variants)
}), function (_ref2) {
  var as = _ref2.as;
  return as === 'textarea' && (0, _css["default"])({
    height: 'auto',
    overflow: 'auto',
    pt: 2,
    resize: 'vertical',
    verticalAlign: 'top'
  });
}, function (_ref3) {
  var as = _ref3.as,
      multiple = _ref3.multiple;
  return as === 'select' && _objectSpread({
    textTransform: 'none',
    wordWrap: 'normal'
  }, multiple ? {
    height: 'auto'
  } : {});
}, function (_ref4) {
  var pushLeft = _ref4.pushLeft,
      pushRight = _ref4.pushRight,
      noneRadiusLeft = _ref4.noneRadiusLeft,
      noneRadiusRight = _ref4.noneRadiusRight;
  return (0, _css["default"])(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, pushLeft ? {
    pl: 10
  } : {}), pushRight ? {
    pr: 10
  } : {}), noneRadiusLeft ? {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  } : {}), noneRadiusRight ? {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  } : {}));
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && (0, _css["default"])({
    bg: 'gray.100'
  });
}, (0, _system.classesStyles)('root'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref6, ref) {
  var size = _ref6.size,
      rest = _objectWithoutProperties(_ref6, ["size"]);

  var context = (0, _FormControlGroupContext.useFormControlGroup)();

  var props = _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    cSize: context.size || size,
    pushLeft: context.pushLeft,
    pushRight: context.pushRight,
    noneRadiusLeft: context.noneRadiusLeft,
    noneRadiusRight: context.noneRadiusRight
  });

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormControl, _objectSpread({}, props));
});
Component.displayName = 'FormControl';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=FormControl.js.map